import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/// ページ遷移時にスクロール位置をトップに戻すコンポーネント
const ScrollRestoration: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollRestoration; 